/**
 * Draft anchor predicate (MC4 — drawing past a viewport frame).
 *
 * A draft "anchor" is the first committed point of an in-progress command
 * (LINE first point, CIRCLE center, etc.). The in-viewport input routing is
 * un-gated from `pointInViewport` ONLY once an anchor exists, so the rubber
 * band may extend PAST the active VP frame (then the render-side clip trims it)
 * — AutoCAD floating-MSPACE parity.
 *
 * Crucially it must be FALSE while a command is merely armed (session present,
 * `points` still empty): otherwise the VERY FIRST point could be placed from
 * OUTSIDE the active viewport frame (the armed-but-no-point state would resolve
 * an outside-frame click to model space). AutoCAD only lets you draw past the
 * frame once an anchor exists inside the VP. (Codex P2, PR #234.)
 *
 * Structural param (no `DraftSession` import) so this stays a THREE-free,
 * dependency-light leaf used by `Scene3DStage` to drive `draftActiveRef`.
 */
export function isDraftAnchored(
  session: { readonly points: readonly unknown[] } | null | undefined,
): boolean {
  return session != null && session.points.length > 0;
}
